/**
 * @author      xinzhe.chai@zumper.com (Xinzhe Chai)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { css } from '@emotion/react'

/** Buttons */
export const big = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  padding: 0 20px;
  font-size: 16px;
  line-height: 16px;
  label: big;
`

export const medium = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 20px;
  font-size: 16px;
  line-height: 16px;
  label: medium;
`

export const small = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  font-size: 14px;
  line-height: 16px;
  label: small;
`

/** Spaces Buttons */
export const spacesBig = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 14px 20px;
  font-size: 18px;
  line-height: 24px;
  min-width: 96px;
  label: big;
`

export const spacesMedium = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 14px 16px;
  font-size: 16px;
  line-height: 20px;
  min-width: 96px;
  label: medium;
`

export const spacesSmall = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 12px 10px;
  font-size: 14px;
  line-height: 16px;
  min-width: 96px;
  label: small;
`

export const leftSelectedGroup = css`
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
`

export const rightSelectedGroup = css`
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
`

export const middleSelectedGroup = css`
  border-radius: 0;
`
